import { MessageDefinition } from '../i18n/messages';

/**
 * The English source text of a message set, keyed the same way as the ids.
 *
 * `t(id)` resolves against `src/i18n/en-US.json`, which is *generated* from the
 * `*.messages.ts` files by `npm run i18n:extract`. Between adding a message and
 * running that script the key is absent from every catalogue, and i18next answers
 * a missing key with the key itself — a freshly added string renders as
 * `consent.banner.title` on the page.
 *
 * Pairing this with `t(Messages.KEY, { defaultValue: Text.KEY })` makes the
 * component render its English text from the moment it is written, and switch to
 * the translated string as soon as the catalogues catch up. The text is still
 * declared exactly once, in the `*.messages.ts` file the extractor reads.
 */
export function englishText<K extends string>(defs: Record<K, MessageDefinition>): Record<K, string> {
    const result = {} as Record<K, string>;
    for (const key in defs) {
        result[key] = defs[key].text;
    }
    return result;
}
